import React, { useEffect, useState } from "react"

import PropTypes from "prop-types"

import * as styles from "./repeater-item.module.scss"
import CopyContainer from "../../atoms/copy-container"
import Heading from "../../atoms/heading"

const RepeaterItem = ({ content, className }) => {
  const [activeAnchor, setActiveAnchor] = useState(0)
  const repeater = content.type === "faq" ? content.questions : content.terms

  useEffect(() => {
    setActiveAnchor(window.location.hash.substr(1))
  }, [])

  return (
    <div className={className}>
      <CopyContainer>
        {repeater.map((item, index) => {
          const itemId = item.term
            ? item.term
                .replace(/\(|\)|\//g, "")
                .replace(/ +/g, "-")
                .toLowerCase()
            : `question${index}`
          return (
            <React.Fragment key={itemId}>
              <Heading
                level="3"
                id={itemId}
                className={`${activeAnchor === itemId ? styles.active : ""}`}
              >
                {item.term || item.question}
              </Heading>
              <CopyContainer content={item._rawDefinition || item._rawAnswer} />
            </React.Fragment>
          )
        })}
      </CopyContainer>
    </div>
  )
}

export default RepeaterItem

RepeaterItem.propTypes = {
  content: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
}
